import isNull from './isNull';
import isUndefined from './isUndefined';

const isNullOrUndefined = (value: unknown): value is null | undefined =>
  isNull(value) || isUndefined(value);

export default isNullOrUndefined;
